import React from 'react';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IProps {
	isFeeFiscalized: boolean;
}

export const IsFeeFiscalizedCheckbox: React.FC<IProps> = ({ isFeeFiscalized }) => {
	const { t } = useTranslation('form');
	const inputValue = isFeeFiscalized ? t('yes') : t('no');

	return (
		<FullInfoField
			label="isFeeFiscalizedLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={isFeeFiscalized ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={isFeeFiscalized}
		/>
	);
};
